import {calcSpacing, s4, s5} from 'web-app/styleguide/spacing';
import {currentTheme} from 'web-app/styleguide';

import type * as Types from './types';

export const MEETING_AUDIO_ID = 'meeting-audio';

export const MEETING_CONTROLS_HEIGHT = 72;

export const getMeetingControlsTopPadding = () => calcSpacing(s5, currentTheme());

export const getMeetingControlsBottomPaddingMobileLandscapeAndLarger = () => calcSpacing(s5, currentTheme());

export const getMeetingControlsBottomPlacementMobileLandscapeAndLarger = () => calcSpacing(s4, currentTheme());

export const getMeetingControlsTotalHeightMobile = () => MEETING_CONTROLS_HEIGHT + getMeetingControlsTopPadding();

export const getMeetingControlsTotalHeightMobileLandscapeAndLarger = () =>
    MEETING_CONTROLS_HEIGHT +
    getMeetingControlsTopPadding() +
    getMeetingControlsBottomPaddingMobileLandscapeAndLarger() +
    getMeetingControlsBottomPlacementMobileLandscapeAndLarger();

export const USER_HAS_CREATED_A_FAMLY_LIVE_MEETING = 'USER_HAS_CREATED_A_FAMLY_LIVE_MEETING';

export const EMPTY_TILE: Types.TileState = {
    tileId: null,
    localTile: false,
    localTileStarted: false,
    isContent: false,
    active: false,
    paused: false,
    poorConnection: false,
    boundAttendeeId: null,
    boundExternalUserId: null,
    boundVideoStream: null,
    boundVideoElement: null,
    nameplate: null,
    videoStreamContentWidth: null,
    videoStreamContentHeight: null,
    videoElementCSSWidthPixels: null,
    videoElementCSSHeightPixels: null,
    devicePixelRatio: 0,
    videoElementPhysicalWidthPixels: null,
    videoElementPhysicalHeightPixels: null,
    streamId: null,
};
